/** Класс маски для поля с датой. */ 
class DateMask {
    constructor(el) {
        this.el = el;
        this.bindEventListeners();
    }

    /**
     * Привязка обработчиков событий.
     * 
     * @returns {void}
     */
    bindEventListeners() {
        this.el.addEventListener("keydown", (event) => {            
            this.designateValidCharacters(event);
            this.addSeparatorToDate(event);
        });
    }

    /**
     * Обозначаем допустимые символы для ввода с клавиатуры.
     * 
     * @returns {void}
     */
    designateValidCharacters(event) {
        /** Разрешаем: backspace, delete, tab и escape */
        if ( event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 ||
            /** Разрешаем: Ctrl+A*/
            (event.keyCode == 65 && event.ctrlKey === true) ||
            /**  Разрешаем: home, end, влево, вправо */
            (event.keyCode >= 35 && event.keyCode <= 39)) {
            
            return;
        } else {
            /**  Запрещаем все, кроме цифр на основной клавиатуре, а так же Num-клавиатуре */
            if ((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105 )) {
                event.preventDefault();
            }
        }
    }

    /**
     * Проставляем точку после второго и пятого символов.
     * 
     * @returns {void}
     */
    addSeparatorToDate(event) {
        const length = this.el.value.length;

        if (length === 2) {
            if (event.keyCode !== 8 && event.keyCode !== 46) { 
                this.el.value = this.el.value+".";
            }
        }
        
        if (length === 5) {
            if (event.keyCode !== 8 && event.keyCode !== 46) { 
                this.el.value = this.el.value+".";
            }
        }
    }
}

window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-date-input")
        .forEach(input => new DateMask(input));
});
